import React from 'react'
import {
    Button,
    ButtonVariants,
    TableItem,
    Typography,
    TypographyTypes,
} from 'rds'
import api from '../../api'
import { SALE_PAYMENT_TYPES } from '../../constants'
import CheckoutFormCardSection from './CheckoutFormCardSection'
import CheckoutFormDiscountCodeBadge from './CheckoutFormDiscountCodeBadge'

const CheckoutFormSubmit = ({
    checkout,
    disabled,
    error,
    isLoading,
    onRemoveDiscount,
    shipmentCost,
    showShipmentCost,
    subTotal,
    submitError,
    total,
}) => {
    const [discounts, setDiscounts] = React.useState([])
    const submitButton = React.useRef()

    const getCheckoutButtonLabel = () => {
        let label
        if (isLoading) {
            label = 'Cargando'
        } else if (checkout.paymentType === SALE_PAYMENT_TYPES.ONLINE) {
            label = 'Pagar ahora'
        } else {
            label = 'Finalizar compra'
        }
        return label
    }

    const fetchDiscounts = async discountIds => {
        if (!discountIds.length) {
            setDiscounts([])
            return
        }
        const url = new URL('discounts', api.defaults.baseURL)
        url.searchParams.append('isActive', true)
        discountIds.forEach(discountId => {
            url.searchParams.append('_id[]', discountId)
        })
        api.get(decodeURIComponent(url)).then(res => {
            setDiscounts(res.data.discounts)
        })
    }

    React.useEffect(() => {
        if (discounts.length !== checkout.discounts.length) {
            fetchDiscounts(checkout.discounts)
        }
    }, [checkout, discounts.length])

    const handleSubmitClick = () => {
        submitButton.current.click()
    }

    return (
        <CheckoutFormCardSection
            className='checkout-form_submit'
            error={submitError || error}
        >
            <div className='checkout-form_submit_details rds-full-block'>
                <div className='rds-full-block rds-flex rds-align-center rds-justify-between'>
                    <Typography type={TypographyTypes.H4}>Subtotal</Typography>
                    <Typography>${subTotal}</Typography>
                </div>
                {showShipmentCost ? (
                    <>
                        <div className='rds-full-block rds-flex rds-align-center rds-justify-between'>
                            <Typography type={TypographyTypes.H4}>
                                Envío
                            </Typography>
                            <Typography>
                                {shipmentCost ? `$ ${shipmentCost}` : 'Gratis'}
                            </Typography>
                        </div>
                        <TableItem className='rds-full-block' />
                    </>
                ) : null}
                {discounts.length ? (
                    <>
                        <div className='rds-full-block'>
                            {discounts.map((discount, index) => (
                                <CheckoutFormDiscountCodeBadge
                                    key={index}
                                    checkout={checkout}
                                    className='rds-flex rds-align-center rds-justify-between'
                                    discount={discount}
                                    onRemove={onRemoveDiscount}
                                />
                            ))}
                        </div>
                        <TableItem className='rds-full-block' />
                    </>
                ) : null}
                <div className='rds-full-block rds-flex rds-align-center rds-justify-between'>
                    <Typography type={TypographyTypes.H4}>Total</Typography>
                    <Typography>${total}</Typography>
                </div>
            </div>
            <div className='checkout-form_submit_actions rds-full-block rds-m_top__md'>
                <input
                    type='submit'
                    style={{ display: 'none' }}
                    ref={submitButton}
                />
                <Button
                    className='rds-full-block rds-text-align_center rds-flex rds-p_top__md rds-p_bottom__md'
                    variant={ButtonVariants.MAIN}
                    label={getCheckoutButtonLabel()}
                    onClick={handleSubmitClick}
                    disabled={disabled}
                />
            </div>
        </CheckoutFormCardSection>
    )
}

export default CheckoutFormSubmit
